import React from "react";
import { Box, Typography } from "@mui/material";
import { ChartBar } from "@phosphor-icons/react";

const EmptySessionUtilization: React.FC = () => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      gap={2}
      py={8}
      color="text.disabled"
    >
      <ChartBar size={40} weight="duotone" />
      <Typography variant="body2" color="text.secondary">
        No session utilization data available
      </Typography>
    </Box>
  );
};

export default EmptySessionUtilization;
